import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import PasswordResetValidator from '../../validators/PasswordResetValidator'
import InputField from '../Inputs/InputField'
import {sections} from '../../utils/variables'
class PageForm extends Component {

    constructor(props) {
	super(props);
	this.state = {
	    waiting: false,
	    status: undefined
	}
    }
    
    componentDidMount(){


    }
    
    render() {
	const { handleSubmit, successAction } = this.props
	let {waiting, status} = this.state;
	const submit = (values, dispatch, props) => {
	    let errors = PasswordResetValidator( values, props ) || {};
	    
	    waiting=true;
	    this.setState({ waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {		
		props.passwordReset(values).then((res) => {
		    waiting=false;
		    status='sent'
		    this.setState({ status,waiting})
		}).catch((err) => {	
		    waiting = false;
		    status = 'error'
		    this.setState({status, waiting})
		})
	    }
	}

	
	return (
	    <div style={{maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto'}}>
		<h1>Izgubil sem geslo</h1>
		{status == 'sent' ?
		 <h2>Poslali smo ti email z inštrukcijami za sprementi geslo</h2>
		 :
		 <form onSubmit={handleSubmit(submit)}>
		     {status == 'error' ?
		      <h2 style={{color: 'red'}}>izbrana email ni registrirana</h2>
		      :
		      ''
		     }
		     <div>
			 <InputField name="email" type="text" label="email" />
			 <button type="submit" disabled={this.props.invalid} className="btn btn-brown btn-big full-width"><i style={{display: (this.state.waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i> Pošlji novo geslo</button>
		     </div>
		     
		     
		     
		 </form>
		 
		}
	    </div> 
	    
	);
    }
}

export default reduxForm({
    form: 'page',
    validate: PasswordResetValidator,
    enableReinitialize: true
})(PageForm);



// WEBPACK FOOTER //
// ./src/components/PasswordReset/index.jsx